export enum EventSourceType {
  WebApp = 1,
  AdminApp = 2,
  System = 3
}
